import { getAppConfig } from '@services/config';

import type { Odr, OdrApiData } from '@app-types/odr';

const appConfig = getAppConfig();
const CMS_IMAGE_BASE = appConfig.assets.cmsImages.url;

export class OdrMapper {
    static apiToOdr(apiData: OdrApiData): Odr {
        const imageUrl =
            (apiData.image as { public_url: string } | null)?.public_url ??
            (typeof apiData.image === 'string'
                ? `${CMS_IMAGE_BASE}/original/image/CMS/ecommerce/${apiData.image}`
                : `${CMS_IMAGE_BASE}/original/image/CMS/ecommerce/wall/lazyload-phone-default-image.svg`);

        return {
            id: apiData.id.toString(),
            title: apiData.title.trim(),
            description: apiData.description?.trim() ?? '',
            universeId: apiData.universe,
            typeId: apiData.odr_type,
            startDate: new Date(apiData.start_date),
            endDate: new Date(apiData.end_date),
            lastDate: new Date(apiData.participation_end_date),
            refundAmount: apiData.price_amount ?? 0,
            imageUrl,
            odrFile: apiData.call_to_action_pdf?.public_url ?? undefined,
            isUntil: Boolean(apiData.price_prefix),
            link: apiData.call_to_action_online ?? undefined,
            duration: apiData.price_period ?? undefined,
            annotation: apiData.tooltip ?? undefined,
            isPercent: apiData.amount_type === 'percent',
            notMoney: apiData.price_description ?? undefined,
            isExpired: new Date(apiData.participation_end_date) < new Date(),
        };
    }

    static apiListToOdrList(apiDataList: OdrApiData[]): Odr[] {
        return apiDataList.map((apiData) => OdrMapper.apiToOdr(apiData));
    }
}
